import React, { useState } from "react";
import { useUser } from "../../Context/UserContext"; // Para obtener los datos del usuario
import { useCompany } from "../../Context/CompanyContext"; // Para obtener la empresa desde el contexto
import { useNavigate } from "react-router-dom"; // Para navegar a otras rutas
import { Button } from "../../components/ui/button";
import { cn } from "../../lib/utils";

const CompanyButtons = ({ companyId, activeTab, setActiveTab }) => {
  const { companies } = useCompany(); // Obtener las empresas asociadas desde el contexto
  const navigate = useNavigate(); // Para navegar a otras rutas

  // Verificar si el usuario tiene una relación con la empresa actual y es Administrador
  const isAdmin =
    companies?.company?.id_company === parseInt(companyId) &&
    companies?.company?.tipo_cuenta === "Administrador" &&
    companies?.company?.estado_usuario === "activo";

  // Estado para las estrellas de evaluación
  const [selectedStars, setSelectedStars] = useState(0);
  const [hoveredStars, setHoveredStars] = useState(0);
  const starColors = ["#d62246", "#f97316", "#eab308", "#4bbf73", "#2A9D8F"];

  return (
    <div className="flex flex-wrap items-center justify-between gap-4 border-b border-border pb-4">
      <div className="flex flex-wrap gap-2">
        <Button variant={activeTab === "perfil" ? "default" : "outline"} onClick={() => setActiveTab("perfil")}>
          Perfil
        </Button>
        <Button variant={activeTab === "reviews" ? "default" : "outline"} onClick={() => setActiveTab("reviews")}>
          Reseñas
        </Button>
        {isAdmin && (
          <>
            <Button
              variant="outline"
              onClick={() => navigate(`/company-profile/${companyId}/admin/identificacion`)}
            >
              Editar
            </Button>
            <Button variant="outline" onClick={() => navigate(`/company-profile/${companyId}/admin/usuarios`)}>
              Socios
            </Button>
          </>
        )}
      </div>

      {!isAdmin && (
        <div className="flex items-center gap-2">
          <p className="text-sm text-muted-foreground">
            <strong className="text-foreground">Evalúa a esta empresa:</strong>
          </p>
          <div className="flex">
            {Array(5)
              .fill(0)
              .map((_, index) => (
                <button
                  key={index}
                  type="button"
                  className={cn("flex h-6 w-6 items-center justify-center rounded-full text-sm")}
                  style={{
                    backgroundColor:
                      hoveredStars >= index + 1 || selectedStars >= index + 1
                        ? starColors[selectedStars || hoveredStars - 1] || "#ccc"
                        : "#ccc",
                    color: "#fff",
                  }}
                  onMouseEnter={() => setHoveredStars(index + 1)}
                  onMouseLeave={() => setHoveredStars(0)}
                  onClick={() => {
                    setSelectedStars(index + 1);
                    navigate("/reseñas", {
                      state: {
                        score: index + 1,
                        reviewTarget: {
                          id_empresa: companyId,
                          nombre_empresa: companies?.company?.nombre_empresa || "Empresa",
                        },
                      },
                    });
                  }}
                >
                  ★
                </button>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CompanyButtons;
